/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsDeactivateRegistryEntry } from "../../funcs/llmModelsDeactivateRegistryEntry.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeactivateModelRegistryEntryRequest$inboundSchema,
};

export const tool$llmModelsDeactivateRegistryEntry: ToolDefinition<
  typeof args
> = {
  name: "llm-models-deactivate-registry-entry",
  description: `Deactivate a model registry name

Idempotently removes the active name and closes its org-scope price rows without touching the catalog definition.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsDeactivateRegistryEntry(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
